export function getTextColor(hexColor: string): "#000000" | "#ffffff" {
  // Convert hex to RGB
  const r = parseInt(hexColor.slice(1, 3), 16);
  const g = parseInt(hexColor.slice(3, 5), 16);
  const b = parseInt(hexColor.slice(5, 7), 16);

  // Linearize RGB channels (remove gamma correction)
  const toLinear = (c: number): number => {
    c /= 255;
    return c <= 0.04045 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  };

  // Calculate relative luminance (WCAG formula)
  const luminance = 0.2126 * toLinear(r) + 0.7152 * toLinear(g) + 0.0722 * toLinear(b);

  // Return black or white based on luminance threshold
  return luminance > 0.179 ? "#000000" : "#ffffff";
}
